// extracted by mini-css-extract-plugin
export var checkmark = "filter-checkbox-module--checkmark--Z6bq6";
export var input = "filter-checkbox-module--input--TV-F1";
export var label = "filter-checkbox-module--label--nMfcJ";
export var text = "filter-checkbox-module--text--+g1cP";